import { useEffect, useRef, useState } from "react";
import "../css/MedicineDetails.css";
import { convertCamelToTitle } from "../../_helper/utils/utils";
import { IoClose } from "react-icons/io5";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { Spinner } from "@react-pdf-viewer/core";
import CuDropdown from "../../common_component/component/CuDropdown";
import { toast } from "react-toastify";

const selectedMed = {
  id: null,
  medicineName: "",
  recentlyUsedCount: 0,
  genericName: {
    name: "",
  },

  dosage: {
    label: "",
    name: "",
  },
  unit: {
    label: "",
    name: "",
  },
  when: {
    label: "",
    name: "",
  },
  frequency: {
    label: "",
    name: "",
  },
  duration: "",
  notes: {
    name: "",
  },
  timing: {
    name: "",
  },
  category: {
    name: "",
  },
};

const MedicineDetails = ({
  closeModal,
  id,
  medicineData,
  setMedicineData,
  medicine_name,
  setSearchInputG,
  setIsSuggestion,
}) => {
  const [selectedDurationOption, setSelectedDurationOption] = useState("DAYS");
  const [formData, setFormData] = useState({
    ...selectedMed,
    medicineName: medicine_name,
  });

  const [searchInput, setSearchInput] = useState({
    medicineName: "",
    genericName: "",
    dosage: "",
    unit: "",
    when: "",
    frequency: "",
    duration: "",
    notes: "",
  });

  const [options, setOptions] = useState({
    medicineName: [],
    genericName: [],
    dosage: [],
    unit: [],
    when: [],
    frequency: [],
    duration: [],
    notes: [],
    medicineType: [],
  });
  const suggestionBoxRef = useRef(null); // Create a ref for the suggestion box

  const { data: getMedicineData, isLoading } = useItemsFilter(
    ApiEndPoint.MEDICINE_DATA,
    `?action=getMedicineData&id=${id}&medicine_data=True`,
    id ? true : false
  );

  // Fetch generic names
  const { data: genericName } = useItemsFilter(
    ApiEndPoint.QP_CM_GENERIC_NAME,
    `?action=getGenericName&frontend=True&name__icontains=${searchInput.genericName}`,
    searchInput?.genericName?.length > 0 ? true : false
  );

  const { data: dosage } = useItemsFilter(
    `master_data/dosage/`,
    `?name=${searchInput?.dosage}`,
    searchInput?.dosage?.length > 0 ? true : false
  );
  const { data: unit } = useItemsFilter(
    `master_data/unit/`,
    `?name=${searchInput?.unit}`,
    searchInput?.unit?.length > 0 ? true : false
  );
  const { data: when } = useItemsFilter(
    `master_data/when/`,
    `?name=${searchInput?.when}`,
    searchInput?.when?.length > 0 ? true : false
  );
  const { data: frequency } = useItemsFilter(
    `master_data/frequency/`,
    `?name=${searchInput?.frequency}`,
    searchInput?.frequency?.length > 0 ? true : false
  );
  const { data: notes } = useItemsFilter(
    `master_data/notes/`,
    `?name=${searchInput?.notes}`,
    searchInput?.notes?.length > 0 ? true : false
  );

  useEffect(() => {
    if (genericName) {
      setOptions((prev) => ({ ...prev, genericName: genericName }));
    }
    if (dosage) {
      // const options = convertIntoOptions("name", dosage);
      setOptions((prev) => ({ ...prev, dosage: dosage }));
    }
    if (unit) {
      // const options = convertIntoOptions("label", unit);
      setOptions((prev) => ({ ...prev, unit: unit }));
    }
    if (when) {
      // const options = convertIntoOptions("label", when);
      setOptions((prev) => ({ ...prev, when: when }));
    }
    if (frequency) {
      // const options = convertIntoOptions("label", frequency);
      setOptions((prev) => ({ ...prev, frequency: frequency }));
    }
    if (notes) {
      // const options = convertIntoOptions("name", notes);
      setOptions((prev) => ({ ...prev, notes: notes }));
    }
  }, [
    genericName,
    dosage,
    unit,
    when,
    frequency,
    notes,
    // medicines,
    // medicine_type,
    // medicine_type,
    // category,
  ]);

  // console.log("FORM DATA", formData);

  // Handle clicking outside the suggestion box
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionBoxRef.current &&
        !suggestionBoxRef.current.contains(event.target)
      ) {
        setOptions([]); // Close the suggestion box when clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [suggestionBoxRef]);

  const handleDurationOptionClick = (option) => {
    setSelectedDurationOption(option);
  };

  useEffect(() => {
    getMedicineData &&
      setFormData((prev) => {
        const newMed = {
          id: getMedicineData?.id,
          medicineName: getMedicineData?.medicine_name,
          recentlyUsedCount: 0,
          genericName: {
            id: getMedicineData?.generic_name?.id,
            name: getMedicineData?.generic_name?.name,
          },
          medicineType: {
            id: getMedicineData?.medicine_type?.id,
            name: getMedicineData?.medicine_type?.name,
            label: getMedicineData?.medicine_type?.label,
          },
          dosage: {
            id: getMedicineData?.dosage?.id,
            label: getMedicineData?.dosage?.label,
            name: getMedicineData?.dosage?.name,
          },
          unit: {
            id: getMedicineData?.unit?.id,
            label: getMedicineData?.unit?.label,
            name: getMedicineData?.unit?.name,
          },
          when: {
            id: getMedicineData?.when?.id,
            label: getMedicineData?.when?.label,
            name: getMedicineData?.when?.name,
          },
          frequency: {
            id: getMedicineData?.frequency?.id,
            label: getMedicineData?.frequency?.label,
            name: getMedicineData?.frequency?.name,
          },
          duration: getMedicineData?.duration,
          notes: {
            id: getMedicineData?.notes?.id,
            name: getMedicineData?.notes?.name,
          },
          timing: {
            name: "",
          },
          category: {
            name: "",
          },
        };

        return newMed;
      });
  }, [id, getMedicineData]);

  // console.log(formData);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Pass the selected medicine data back to the parent component
    setMedicineData([...medicineData, formData]);
    setSearchInputG("");
    setIsSuggestion(false);
    // setIsSuggestion(false);
    closeModal(); // Close the modal after adding the medicine
  };

  const clearSearchAndSuggestion = () => {
    setSearchInput({
      medicineName: "",
      genericName: "",
      dosage: "",
      unit: "",
      when: "",
      frequency: "",
      duration: "",
      notes: "",
      medicineType: "",
    });
    setOptions({
      medicineName: [],
      genericName: [],
      dosage: [],
      unit: [],
      when: [],
      frequency: [],
      duration: [],
      notes: [],
      medicineType: [],
    });
  };

  const handleChange = (val, label) => {
    setFormData({ ...formData, [label]: { name: val } });
    setSearchInput({ ...searchInput, [label]: val });
    // setGenericNameSearchInput(val);
  };

  const handleSelect = (val, label) => {
    setFormData({ ...formData, id: Date.now(), type: "new", [label]: val });
    clearSearchAndSuggestion();
  };

  return (
    <>
      {isLoading ? (
        <div className="flex items-center justify-center h-screen text-gray-700">
          <Spinner size={18} />
          <p className="ml-2 "> Please wait...</p>
        </div>
      ) : (
        <>
          {" "}
          <div className="flex justify-between items-center my-3 px-3">
            <span className="text-[#393939] text-[15px]">
              {getMedicineData?.medicine_name}
            </span>
            <IoClose size={25} color="#393939" onClick={closeModal} />
          </div>
          <form
            className="cu-mobile-consultation-medicine-details"
            onSubmit={handleSubmit}
          >
            {Object.keys(formData)?.map((key) => {
              if (
                key !== "id" &&
                key !== "category" &&
                key !== "timing" &&
                key !== "recentlyUsedCount"
              ) {
                if (key === "duration") {
                  return (
                    <div
                      key={key}
                      className="cu-mobile-consultation-medicine-details-input"
                    >
                      <label>{convertCamelToTitle(key)}</label>
                      <div className="cu-mobile-consultation-medicine-details-duration-input">
                        <input
                          className="flex-1"
                          placeholder="0"
                          value={formData[key]}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              duration: e.target.value,
                            })
                          }
                        />
                        <span
                          className={`cu-mobile-consultation-medicine-details-duration-option ${
                            selectedDurationOption === "DAYS"
                              ? "bg-[#F2FBF3]"
                              : ""
                          }`}
                          onClick={() => handleDurationOptionClick("DAYS")}
                        >
                          DAYS
                        </span>
                        <span
                          className={`cu-mobile-consultation-medicine-details-duration-option ${
                            selectedDurationOption === "WEEKS"
                              ? "bg-[#F2FBF3]"
                              : ""
                          }`}
                          onClick={() => handleDurationOptionClick("WEEKS")}
                        >
                          WEEKS
                        </span>
                        <span
                          className={`cu-mobile-consultation-medicine-details-duration-option ${
                            selectedDurationOption === "MONTHS"
                              ? "bg-[#F2FBF3]"
                              : ""
                          }`}
                          onClick={() => handleDurationOptionClick("MONTHS")}
                        >
                          MONTHS
                        </span>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={key}
                      className="cu-mobile-consultation-medicine-details-input"
                    >
                      <label>{convertCamelToTitle(key)}</label>
                      <input
                        type="text"
                        className="cu-consultation-medicinedetails-input"
                        value={
                          typeof formData[key] == "object"
                            ? formData[key]?.name
                            : formData[key]
                        }
                        onChange={(e) =>
                          handleChange(e.target.value.toUpperCase(), key)
                        }
                      />
                      {options[key]?.length > 0 && (
                        <div
                          className="cu-consultation-medicine-suggestion-list-mobile"
                          ref={suggestionBoxRef} // Attach ref to suggestion list
                        >
                          {options[key]?.map((option, opidx) => {
                            // console.log(option);
                            return (
                              <div
                                className={`cu-consultation-medicine-suggestion-list-item-mobile`}
                                key={option?.id}
                                onClick={() => handleSelect(option, key)}
                                // ref={(el) => (optionRef.current[opidx] = el)}
                              >
                                {option?.name}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                }
              }
            })}
            <div className="border-t py-2 px-4">
              <button
                type="submit"
                className="cu-mobile-consultation-medicine-details-submit-btn"
              >
                Add Medicine
              </button>
            </div>
          </form>
        </>
      )}
    </>
  );
};

export default MedicineDetails;
